// removed by extract-text-webpack-plugin
module.exports = {"item":"src-components-modules-FaqItem-style----general-module---item---3PVDc position-relative lineHeight-copy overflow-hidden","heading":"src-components-modules-FaqItem-style----general-module---heading---2JbiB textAlign-left fontWeight-5 breakPointS-fontSize-s breakPointM-fontSize-s breakPointL-fontSize-m fontSize-m","subtitle":"src-components-modules-FaqItem-style----general-module---subtitle---3EwY- textAlign-left c-slate breakPointS-fontSize-s breakPointM-fontSize-s breakPointL-fontSize-m fontSize-m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/FaqItem/style/general.module.css
// module id = 734
// module chunks = 18116671869107 275075819617530